"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.userInitialState = void 0;

var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/set"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/map"));

var _IPerson = require("../models/IPerson");

var userInitialState = {
  organizations: [],
  organizationsById: new _map.default(),
  flights: {
    isLoading: true,
    value: new _set.default()
  },
  userPerson: {
    objectId: '',
    displayName: '',
    userPrincipalName: '',
    department: '',
    userState: _IPerson.UserStates && _IPerson.UserStates.Accepted,
    userType: _IPerson.UserTypes && _IPerson.UserTypes.Member
  },
  auth: {
    isAuthenticated: false,
    userName: ''
  },
  isLoading: true,
  isCurrentOrgLoading: false,
  isCurrentOrgLoadingError: false,
  isOrganizationsByIdLoading: false,
  isOrganizationsByIdLoadingError: false
};
exports.userInitialState = userInitialState;